/**
 * @description
 * Objeto AvisEstat
 */

export class AvisEstat {
    public id:number = null;
    public code:string = "";
    public descript:string = "";

    constructor() {}
}